import type { Game } from './types.js';

export interface GameRelease {
  kind: 'new' | 'major';
  at: string;
  version: string;
  estimated: boolean;
}

/** Pre-release labels and arbitrary build names do not announce a major release. */
export function releaseMajor(version: string): number | null {
  const match = /^v?(0|[1-9]\d*)(?:\.(?:0|[1-9]\d*)){0,2}(?:\+[\da-z.-]+)?$/i.exec(version.trim());
  if (!match) return null;
  const major = Number(match[1]);
  return Number.isSafeInteger(major) ? major : null;
}

export function latestGames(games: Game[], limit = 6): Game[] {
  return games
    .filter((game) => game.published && game.latestRelease && !game.categories.includes('测试游戏'))
    .sort(
      (a, b) => b.latestRelease!.at.localeCompare(a.latestRelease!.at) || a.id.localeCompare(b.id),
    )
    .slice(0, limit);
}
